//@flow
import api from '../Utils/apiBuilder';
import Constants from '../constants';

export default {
  getStock() {
    return api('stock').noauth().get().dispatch(Constants.GET_STOCK_SUCCESS);
  },
};
